import httpService from '@/modules/common/services/httpService';
import { PULSE_PAGE_LIMIT } from '@/modules/pulse/utils/pulseConstants';

const apiService = httpService.create(window.pov_config.VUE_APP_API_URL_GATEWAY);
const baseRoute = 'v3/ai/pulse_items';

const getPulseItems = async ({ view, category, cursor, limit = PULSE_PAGE_LIMIT } = {}) => {
  const params = { view, category, limit };
  if (cursor) params.cursor = cursor;
  const res = await apiService.get(baseRoute, params);
  return res.data.data;
};

const getPulseItem = async (uid) => {
  const res = await apiService.get(`${baseRoute}/${uid}`);
  return res.data.data.pulse_item;
};

const executePulseItem = async (uid) => {
  const res = await apiService.post(`${baseRoute}/${uid}/execute`);
  return res.data.data;
};

const markPulseItemAsCompleted = async (uid) => {
  const res = await apiService.post(`${baseRoute}/${uid}/mark-as-completed`);
  return res.data.data;
};

const dismissPulseItem = async (uid) => {
  const res = await apiService.post(`${baseRoute}/${uid}/dismiss`);
  return res.data.data;
};

export default {
  getPulseItems,
  getPulseItem,
  executePulseItem,
  markPulseItemAsCompleted,
  dismissPulseItem,
};
